<template>
  <VView class="gallery-item" back-button-to="/gallery" :header="$t('gallery.header')">
    <VMedia class="gallery-item__frame">
      <img :src="$route.query.url" />
    </VMedia>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VText from '@/components/VText.vue';
import VMedia from '@/components/VMedia.vue';

export default {
  name: 'GalleryItem',
  components: {
    VView,
    VText,
    VMedia,
  },
};
</script>

<style lang="scss" scoped>
.gallery-item {
  &__frame {
    margin: 0 auto;
  }
}
</style>
